import { c as t } from "../../../../index.esm-BeDSGXP5.js";
import { css as o } from "styled-components";
const s = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20aria-label='disc'%20width='24px'%20height='24px'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2024%2024'%20enable-background='new%200%200%2024%2024'%20xml:space='preserve'%3e%3cg%3e%3ccircle%20cx='12'%20cy='12'%20r='4'%20fill='%231C2640'/%3e%3c/g%3e%3c/svg%3e", i = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20aria-label='disc'%20width='24px'%20height='24px'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2024%2024'%20enable-background='new%200%200%2024%2024'%20xml:space='preserve'%3e%3cg%3e%3ccircle%20cx='12'%20cy='12'%20r='4'%20fill='%23ffffff'/%3e%3c/g%3e%3c/svg%3e", a = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20aria-label='new-tab'%20width='24px'%20height='24px'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2024%2024'%20enable-background='new%200%200%2024%2024'%20xml:space='preserve'%3e%3cg%3e%3cpath%20fill='%23007B90'%20d='M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z%20M16,17.47H6.5V8.03h4v1.5H8v6.44h6.5%20v-2.5H16V17.47z%20M17.5,11.03l-1.72-1.72l-4.58,4.58l-1.06-1.06l4.58-4.58L13,6.53l4.5,0V11.03z'/%3e%3c/g%3e%3c/svg%3e", r = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20aria-label='new-tab'%20width='24px'%20height='24px'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2024%2024'%20enable-background='new%200%200%2024%2024'%20xml:space='preserve'%3e%3cg%3e%3cpath%20fill='%23ffffff'%20d='M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z%20M16,17.47H6.5V8.03h4v1.5H8v6.44h6.5%20v-2.5H16V17.47z%20M17.5,11.03l-1.72-1.72l-4.58,4.58l-1.06-1.06l4.58-4.58L13,6.53l4.5,0V11.03z'/%3e%3c/g%3e%3c/svg%3e", l = (n) => n.components.markdown.assets, c = ({ variant: n, theme: e }) => /* @__PURE__ */ o([
  "",
  " p{",
  " ",
  " color:currentColor;}h1,h2,h3{",
  " color:currentColor;}h1{",
  "}h2{",
  "}h3{",
  "}a{",
  " position:relative;color:currentColor;&[target='_blank']{position:relative;background-image:",
  ";background-repeat:no-repeat;background-position:right 50%;background-size:contain;padding-right:",
  ";}}strong{font-weight:",
  ";}em{font-style:italic;}"
], e.components.text.base, e.components.text.base, e.components.text.paragraph, e.components.heading.base, e.components.heading.large, e.components.heading.medium, e.components.heading.small, e.components.link.base, `url("${l(e).newTab[n]}")`, e.space.md, e.fontWeights.medium), g = ({ variant: n, theme: e }) => /* @__PURE__ */ o([
  "ul{",
  "}li{",
  "}ul li{",
  " list-style-type:none;background:",
  " -7px top no-repeat;background-size:2.4rem 2.4rem;}ol{",
  " ",
  "}ol li{list-style-type:decimal;",
  "}"
], e.components.list.base, e.components.list.listItem, t({
  paddingLeft: [
    "md",
    null,
    "lg"
  ]
}), `url("${l(e).li[n]}")`, e.resets.space, t({
  paddingLeft: [
    "md",
    null,
    "lg"
  ]
}), t({
  paddingLeft: [
    "xs",
    null,
    "sm"
  ]
})), d = {
  assets: {
    li: {
      dark: s,
      light: i
    },
    newTab: {
      dark: a,
      light: r
    }
  },
  base: ({ size: n, theme: e }) => /* @__PURE__ */ o([
    "",
    " ",
    " ",
    ""
  ], e.components.text[n], c, g),
  light: ({ theme: n, color: e }) => /* @__PURE__ */ o([
    "",
    " p{",
    " color:",
    ";}a{",
    " color:",
    ";}"
  ], n.components.text.light, n.components.text.light, e ? "currentColor" : void 0, n.components.link.light, e ? "currentColor" : void 0),
  dark: ({ theme: n, color: e }) => /* @__PURE__ */ o([
    "",
    " p{",
    " color:",
    ";}a{",
    " color:",
    ";}"
  ], n.components.text.dark, n.components.text.dark, e ? "currentColor" : void 0, n.components.link.dark, e ? "currentColor" : void 0)
};
export {
  d as default
};
